export const FETCH_VENDORS_SUCCESS = 'fetch_vendors_success'
export const ADD_VENDOR_SUCCESS = 'add_vendor_success'
export const FETCH_VENDOR_DETAILS_SUCCESS = 'fetch_vendor_details_success'
export const UPDATE_VENDOR_SUCCESS = 'update_vendor_success'
export const FETCH_VENDOR_METRICS_SUCCESS = 'fetch_vendor-metrics_success'
